import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneItem(additionalControls: string[], customError: string): ValidatorFn | null {
  return (control: AbstractControl): ValidationErrors => {
    let valuesCount = control.value instanceof Array ? control.value.length : 0;

    valuesCount = additionalControls
      .map((a: string) =>
        control.root.get(a) !== null && control.root.get(a).value instanceof Array
          ? control.root.get(a).value.length
          : 0
      )
      .reduce((a, b) => a + b, valuesCount);

    return valuesCount > 0 ? null : { customMessage: customError };
  };
}
